import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-081709ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "catalog-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallCardPreloaderComponent = _resolveComponent("SmallCardPreloaderComponent")!
  const _component_SmallCardComponent = _resolveComponent("SmallCardComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (row) => {
      return _withDirectives(_createVNode(_component_SmallCardPreloaderComponent, null, null, 512), [
        [_vShow, _ctx.getCardsPreloaders.novelty]
      ])
    }), 64)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNoveltyMods, (row) => {
      return _withDirectives((_openBlock(), _createBlock(_component_SmallCardComponent, { data: row }, null, 8, ["data"])), [
        [_vShow, !_ctx.getCardsPreloaders.novelty]
      ])
    }), 256))
  ]))
}